import React from 'react'
import { useLocation, useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { useQuery } from '@/utils/hooks/useQuery'
import { Menu } from '@/components/navigation/Menu'

import { sections } from '../../playbook.helpers'
import { ChecklistEditor } from './ChecklistEditor'
import { ChecklistVariationsEditor } from './ChecklistVariationsEditor'
import './Checklist.scss'

export const ChecklistTabs = () => {
  const location = useLocation()
  const { id: playbookId, entryId } = useParams()
  const isCreate = entryId === 'create'
  const query = useQuery()
  const isVariationsTab = query.get('tab') === 'variations'
  const {
    playbook: { current: isLatestPlaybookVersion },
  } = useSelector((state) => state.playbook)
  const tabs = [
    {
      route: sections.CHECKLIST,
      title: 'Details',
    },
  ]

  if (isLatestPlaybookVersion && !isCreate) {
    tabs.push({
      route: sections.CHECKLIST,
      title: 'Variations',
      query: 'variations',
    })
  }

  const isActiveChecklistTab = (match, tab) => {
    if (!match) {
      return false
    }

    if (isVariationsTab && query.get('tab') === tab.query && location.search.includes(query)) {
      return true
    }

    if (!isVariationsTab && !query.get('tab') && !tab.query) {
      return true
    }

    return false
  }

  return (
    <div className="checklist-tabs-container">
      <Menu
        items={tabs.map((tab) => ({
          accessor: tab.title,
          label: tab.title,
          to: `/playbooks/${playbookId}/${tab.route}/${entryId}${
            tab.query ? `?tab=${tab.query}` : ''
          }`,
          isActive: (match) => isActiveChecklistTab(match, tab),
          dataTestId: `checklist-navigation-${tab.route}-tab${tab.query ? `-${tab.query}` : ''}`,
        }))}
      />
      {isVariationsTab ? <ChecklistVariationsEditor /> : <ChecklistEditor />}
    </div>
  )
}
